import { configureStore } from "@reduxjs/toolkit";
import profileSlice from "./profile.Slice";

export const store=configureStore({
    reducer:{
        profile:profileSlice
    }
})